import { Badge, Box, desktopFirstMediaQuery } from '@inflearn/ds-react';
import React from 'react';

type Props = {
  tags: string[];
};

const SessionTags = ({ tags }: Props) => {
  return (
    <Box
      component="section"
      css={{
        display: 'flex',
        marginBottom: '32px',
        flexWrap: 'wrap',
        [desktopFirstMediaQuery.mobile]: {
          overflowX: 'auto',
          flexWrap: 'nowrap',
          marginBottom: '24px',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none'
          }
        }
      }}>
      {tags.map((tag) => (
        <Badge
          mb={8}
          mr={8}
          key={tag}
          variant="light"
          color="gray"
          size="lg"
          radius="sm"
          css={{ flexShrink: 0 }}>
          {tag}
        </Badge>
      ))}
    </Box>
  );
};

export default SessionTags;
